import {accountPaths} from '~/utils/services/paths';
import type {IBillingData, IBillingDataItemUpdate} from '~/types';

export const getBillingData = async (userEmail: string) => {
    return await $cpFetch<IBillingData>(accountPaths.billingData(userEmail));
};

export const addBillingData = async (userEmail: string, billingData: IBillingDataItemUpdate) => {
    return await $cpFetch<IBillingData>(accountPaths.billingData(userEmail), {
        method: 'POST',
        body: {...billingData, autoSelect: true},
    });
};

export const editBillingData = async (
    userEmail: string,
    {billingData, billingDataId} : { billingData: IBillingDataItemUpdate, billingDataId: string }) => {
    return await $cpFetch(accountPaths.billingDataSingle(userEmail, billingDataId), {
        method: 'PUT',
        body: {...billingData, autoSelect: true},
    });
};

export const deleteBillingData = async (userEmail: string, idBillingData: string) => {
    return await $cpFetch<IBillingData>(accountPaths.billingDataSingle(userEmail, idBillingData), {
        method: 'DELETE',
    });
};

export const selectBillingData = async (userEmail: string, idBillingData: string, status: boolean) => {
    return await $cpFetch<IBillingData>(accountPaths.billingDataSelect(userEmail, idBillingData), {
        method: 'PATCH',
        body: {
            selected: status,
        },
    });
};
